export default __webpack_public_path__ + "static/media/phone.de509af7.svg";